/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IDiaglabEquipment } from 'app/shared/model/diaglab-equipment.model';
import { IDoctor } from 'app/shared/model/doctor.model';
import { IDiaglabBill } from 'app/shared/model/diaglab-bill.model';
import { IRadiologyPricing } from 'app/shared/model/radiology-pricing.model';
import { IRadiologyStudy } from 'app/shared/model/radiology-study.model';
import { IPaymentScheme } from 'app/shared/model/payment-scheme.model';
import { ProcedurePriority } from 'app/shared/model/enumerations/procedure-priority.model';

export interface IRadiologyBillItem {
  id?: string;
  price?: number;
  discount?: number | null;
  active?: boolean;
  cursor?: number;
  lastupdated?: number;
  microSec?: number;
  timestampentry?: number;
  statusCode?: string;
  accessionNo?: string;
  scheduledTime?: number;
  procedurePriority?: keyof typeof ProcedurePriority | null;
  paidAmount?: number | null;
  scheduledAt?: IDiaglabEquipment | null;
  performedBy?: IDoctor | null;
  referTo?: IDoctor | null;
  diaglabBill?: IDiaglabBill | null;
  radiologyPricing?: IRadiologyPricing | null;
  radiologyStudy?: IRadiologyStudy | null;
  scheme?: IPaymentScheme | null;
}

export const defaultValue: Readonly<IRadiologyBillItem> = {
  active: false,
};
